export var modes = {
    // menuHidden: 'menuHidden',
    menuShowing: 'menuShowing',
    takingPhoto: 'takingPhoto',
    confirmPhoto: 'confirmPhoto',
    noFaceDetected: 'noFaceDetected',
    videoShowing: 'videoShowing',
    canvasShowing: 'canvasShowing',
    photoCanvasShowing: 'photoCanvasShowing',
    modelCanvasShowing: 'modelCanvasShowing',
    imageLoaded: 'imageLoaded'
    // video: 'video',
    // photo: 'photo',
};

// export function validateSkusSingle(skus, currentSkuMap){
//     skus = skus.map(s => { return { sku: s.skuId, region: s.region } });
//     return {skuArray: [skus[0]], skuMap: new Map([[skus[0].region, skus[0].sku]])};
// }
export function validateSkus(skus, currentSkuMap) {
    skus = skus.map(function (s) {
        s.sku = s.skuId;return s;
    });
    var skuMap = new Map();
    for (var q = 0; q < skus.length; q++) {
        if (['gloss', 'lipstick'].indexOf(skus[q].region) < 0 || skus[q].region == 'gloss' && !skuMap.has('lipstick') || skus[q].region == 'lipstick' && !skuMap.has('gloss')) {
            skuMap.set(skus[q].region, skus[q]);
        }
    }
    ////add any previous applied skus
    // for (var [key, value] of currentSkuMap.entries()) {
    //     if (!skuMap.has(key) &&
    //         ((key == 'gloss' && !skuMap.has('lipstick')) ||
    //             (key == 'lipstick' && !skuMap.has('gloss')))) {
    //         skuMap.set(key, value);
    //     }
    // }
    var skuArray = [];
    for (var _iterator = skuMap, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref2 = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref2 = _i.value;
        }

        var _ref = _ref2;
        var key = _ref[0];
        var value = _ref[1];

        skuArray.push(value);
    }

    return { skuArray: skuArray, skuMap: skuMap };
}

export var reStyleCategory = 'hair';